<!--
Author: TangChen
Date: 2019-04-08
Desc: 图片上传
 -->
<template>
    <div class="comp-img-upload comp">
        <el-row class="up-list" :span="24">
            <el-form v-if="flag === '0'" ref="img" :model="img" :rules="rules">
                <el-form-item label="" prop="front">
                    <p class="up-list-mes">
                        1、机构营业执照（需加盖公章）
                    </p>
                    <div class="img-up-list el-upload-list--picture-card">
                        <div v-if="img.front">
                            {{img.front}}
                        </div>
                        <el-input
                            ref="front"
                            v-model="img.front"
                            type="file"
                            name="front"
                            :accept="accept"
                            v-on:change="getImgBase"
                        />
                        <div class="img-up" v-if="!img.front">
                            <!--<img v-if="imgBase64.front" :src="imgBase64.front">-->
                            <i class="el-icon-plus" />
                            <span class="img-text">营业执照</span>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item label="" prop="idCard">
                    <p class="up-list-mes">
                        2、银行开具的不低于300万资产证明（加盖银行业务章），或者近3年个人年均收入不低于30万元的证明（加盖公司公章）
                    </p>
                    <div class="img-up-box">
                        <div class="img-up-list el-upload-list--picture-card">
                            <div v-if="img.back">
                                {{img.back}}
                            </div>
                            <el-input
                                ref="back"
                                v-model="img.back"
                                type="file"
                                name="back"
                                :accept="accept"
                                v-on:change="getImgBase"
                            />
                            <div class="img-up" v-if="!img.back">
                                <i class="el-icon-plus" />
                                <span class="img-text">净资产扫描件</span>
                            </div>
                        </div>
                        <div class="img-up-list el-upload-list--picture-card">
                            <div v-if="img.asset">
                               {{img.asset}}
                            </div>
                            <el-input
                                ref="asset"
                                v-model="img.asset"
                                type="file"
                                name="asset"
                                :accept="accept"
                                v-on:change="getImgBase"
                            />
                            <div class="img-up" v-if="!img.asset">
                                <i class="el-icon-plus" />
                                <span class="img-text">金融资产扫描件</span>
                            </div>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item label="" prop="invest">
                    <p class="up-list-mes">
                        3、两年以上或一年以上证券、基金、期货、基金、外汇等投资经历或者两年以上或一年以上金融产品设计、投资、风险管理及相关工作经历
                    </p>
                    <div class="img-up-list el-upload-list--picture-card">
                        <div v-if="img.invest" >
                           {{img.invest}}
                        </div>
                        <el-input
                            ref="invest"
                            v-model="img.invest"
                            type="file"
                            name="invest"
                            :accept="accept"
                            v-on:change="getImgBase"
                        />
                        <div class="img-up" v-if="!img.invest">
                            <i class="el-icon-plus" />
                            <span class="img-text">工作经历证明</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="" class="btn-center">
                    <el-button type="primary" class="medium" v-on:click="submitInfo()">
                        上传
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        还未准备好
                    </el-button>
                </el-form-item>
            </el-form>
            <el-form v-else ref="img" :model="img" :rules="rules" v-on:submit.native.prevent>
                <el-form-item label="" prop="qualified">
                    <p class="up-list-mes">
                        1、合格投资者证件照或文件
                    </p>
                    <div class="img-up-list el-upload-list--picture-card">
                        <div v-if="img.qualified">
                            {{img.qualified}}
                        </div>
                        <el-input
                            ref="qualified"
                            v-model="img.qualified"
                            type="file"
                            name="qualified"
                            :accept="accept"
                            v-on:change="getImgBase"
                        />
                        <div class="img-up" v-if="!imgBase64.qualified">
                            <i class="el-icon-plus" />
                            <span class="img-text">合格投资者证明</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="" class="btn-center">
                    <el-button type="primary" class="medium" v-on:click="submitInfo()">
                        上传
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        还未准备好
                    </el-button>
                </el-form-item>
            </el-form>
            <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl">
            </el-dialog>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "ImgUpload",
    props: {
        flag: {
            type: String,
            default: "0"
        }
    },
    data () {
        return {
            dialogImageUrl: "",
            dialogVisible: false,
            accept: "application/pdf",
            img: {
                idCard: "",
                front: "",
                back: "",
                asset: "",
                invest: ""
            },
            imgBase64: {
                front: "",
                back: "",
                asset: "",
                invest: ""
            },
            rules: {
                idCard: [
                    { validator: this.validateImg, trigger: "change" }
                ],
                front: [
                    { required: true, message: "请选择机构营业执照", trigger: "change" }
                ],
                invest: [
                    { required: true, message: "请选择工作经历证明文件上传", trigger: "change" }
                ]
            },
            upload_url: "/acct/changetype/upload",
            uploadForm: new FormData()
        };
    },
    watch: {
        "img.asset" (val) {
            this.img.idCard = (val && this.img.back) ? "1" : "";
        },
        "img.back" (val) {
            this.img.idCard = (val && this.img.asset) ? "1" : "";
        }
    },
    methods: {
        handlePictureCardPreview (filename) {
            this.dialogImageUrl = this.imgBase64[filename];
            this.dialogVisible = true;
        },
        validateImg (rule, value, callback) {
            if (value) {
                callback();
            } else {
                if (!this.img.asset && !this.img.back) {
                    callback(new Error("请上传净资产及金融资产扫描件"));
                }
                if (!this.img.asset) {
                    callback(new Error("请上传金融资产扫描件"));
                }
                if (!this.img.back) {
                    callback(new Error("请上传净资产扫描件"));
                }
            }
        },
        submitInfo () {
            const _this = this;
            _this.upload_url = _this.$route.query.flag === "1" ? "pef/file/upload/base64" : "/acct/changetype/upload/base64";
            const _x = this.$util.src(_this.upload_url,{},true);
            _this.$refs.img.validate(valid => {
                if (valid) {
                    this.$req({
                        method: "POST",
                        url: _x,
                        timeout: 20000,
                        data: _this.imgBase64,
                        headers: { "Content-Type": "multipart/form-data" }
                    }).then(res => {
                        if (res.code === "0000000") {
                            _this.$emit("success", true);
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(() => { });
                } else {
                    return false;
                }
            });
        },
        getImgBase () {
            const _this = this;
            const event = window.event;
            const file = event.target && event.target.files[0] ? event.target.files[0] : {};
            let k = 0;
            if (!file) {
                this.delImg(event.target.name);
                return false;
            }
            if(file.type&&file.type.indexOf("pdf")===-1){
                this.$message.warning("专业投资者转换上传资料需仅支持pdf");
                this.delImg(event.target.name);
                return
            }
            if (file.size > 1024 * 1024 * 5) {
                this.img[event.target.name] = "";
                this.$message.warning("上传文件大小超过限制大小5M，不能上传");
                return;
            }
            for (let i in this.img) {
                if (this.img[i] && file.name === this.img[i].split("\\").pop()) k++;
            }
            if (k === 2) {
                this.delImg(event.target.name);
                this.$message.warning("不能上传相同名称的文件，请重新上传");
                return false;
            }
            const reader = new FileReader();
            // 转base64
            reader.onload = function (e) {
                _this.$set(_this.imgBase64, event.target.name, e.target.result);
            };

            try{
                this.uploadForm.delete(event.target.name);
            }catch (e) {
                console.log(e);
            }
            this.uploadForm.append(event.target.name, file);
            reader.readAsDataURL(file);
        },
        // 删除图片
        delImg (index) {
            this.imgBase64[index] = "";
            if (this.img[index]) {
                this.img[index] = "";
                this.uploadForm.delete(index);
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-img-upload {
    .btn-center {
        text-align: center;
    }
    .up-list {
        padding: 20px 0;
        .up-list-mes {
            font-size: $f16;
            color: $text-color2;
            line-height: 30px;
        }
        .img-up-list {
            margin-top: 20px;
            display: inline-block;
            position: relative;
            .el-upload-list__item-actions {
                z-index: 100;
                i {
                    font-size: $f24;
                    cursor: pointer;
                }
                i:last-of-type {
                    margin-left: 20px;
                }
            }
            .el-input {
                position: absolute;
                top: 10px;
                left: 0;
                opacity: 0;
                z-index: 10;
            }
            .img-up,
            .el-input .el-input__inner {
                width: 100%;
                cursor: pointer;
            }
            .img-up {
                text-align: center;
                border: 3px dashed $border-color4;
                border-radius: 10px;
                background-color: $bg1;
                overflow: hidden;
                img {
                    width: 240px;
                    height: 150px;
                    display: inline-block;
                }
            }
            .img-text {
                vertical-align: middle;
                font-size: $f20;
            }
            .el-icon-plus {
                vertical-align: middle;
                font-size: $f26;
                margin-right: 7px;
                color: inherit;
                font-weight: bold;
            }
        }
        .img-up-box {
            .img-up-list {
                vertical-align: middle;
                &:last-of-type {
                    margin-left: 24px;
                }
            }
        }
    }
}
</style>
